<div class="main-header">
    <div class="branding">
      <div class="app-header__brand">
        <span class="app-header__logo">audit</span>
        <span class="app-header__divider">|</span>
        <img src="assets/images/svg/Logo-black.png" alt="Swipesum Logo" class="app-header__partner">
      </div>
    </div>
</div>
<div style="display: flex; justify-content: center; align-items: center;">
    <h1>landing works!</h1>
</div>
<div style="display: flex; justify-content: center; align-items: center;">
    <h2> You are seeing this page because you are not logged in or do not have an account setup.</h2>
</div>
<div style="display: flex; justify-content: center; align-items: center; gap: 10px;">
    <button class="primary" (click)="signIn()">Sign In</button>
    <button class="primary" (click)="signUp()">Sign Up</button>
</div>

<swipesum-footer appName="audit" class="footer-container"></swipesum-footer>
